import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-address-display',
  templateUrl: './address-display.component.html',
})
export class AddressDisplayComponent {
  @Input() address;

}



// WEBPACK FOOTER //
// ./src/app/shared/components/address/address-display.component.ts